import {useCallback} from 'react';
import urls from 'urls';
import {useDispatch, useSelector} from 'react-redux';
import {Button} from '~library/atoms/Button';
import {Picture} from '~library/atoms/Picture';
import {Typography} from '~library/atoms/Typography';
import {centsToDollarDisplay} from '~/common/utils/payment_utils';
import {
  selectRetailer,
  selectValue,
  TOGGLE_E_GIFT_CARDS_DRAWER,
  UPDATE_E_GIFT_CARD_USER_DISABLED,
} from '~/common/fabric/GiftCard/reducers/eGiftCard';
import {PlusIcon} from '~library/svg/PlusIcon';

import './RetailerImage.sass';

export const RetailerImage = ({disabled}) => {
  const dispatch = useDispatch();
  const retailer = useSelector(selectRetailer);
  const value = useSelector(selectValue);

  const onSwitchHandler = useCallback(() => {
    dispatch({
      type: UPDATE_E_GIFT_CARD_USER_DISABLED,
      payload: !disabled,
    });
  }, [disabled, dispatch]);

  const onClickChangeRetailerHandler = useCallback(() => {
    dispatch({type: TOGGLE_E_GIFT_CARDS_DRAWER, payload: true});
  }, [dispatch]);

  return (
    <div className="retailer-image-wrapper">
      {disabled ? (
        <Button
          data-qa-id="enable-gift-cards-via-logo-button"
          variant="transparent"
          onClick={onSwitchHandler}
          className="image disabled-retailer"
        >
          <PlusIcon ratio={2} />
          <Typography variant="paragraph1" className="retailer-enable-action" as="span">
            Add eGift Card
          </Typography>
          <div className="retailer-icons">
            <Picture
              srcSet={urls.get('cdn_logos', {image: 'target-logo.svg'})}
              alt="Target Logo"
              className="disabled-retailer__image"
            />
            <Picture
              srcSet={urls.get('cdn_logos', {image: 'gamestop-logo.svg'})}
              alt="GameStop Logo"
              className="disabled-retailer__image"
            />
            <Picture
              srcSet={urls.get('cdn_logos', {image: 'starbucks-logo.svg'})}
              alt="Starbucks Logo"
              className="disabled-retailer__image"
            />
            <Picture
              srcSet={urls.get('cdn_logos', {image: 'amazon-logo.svg'})}
              alt="Amazon Logo"
              className="disabled-retailer__image"
            />
            <Typography variant="list2" classNames="disabled-retailer__and-more-text">
              + many more!
            </Typography>
          </div>
        </Button>
      ) : (
        <>
          <Button
            data-qa-id="retailer-image-switch"
            onClick={onClickChangeRetailerHandler}
            variant="transparent"
            disableProcessing
          >
            <Picture
              srcSet={retailer?.image || ''}
              alt={`${retailer?.product_config_name || ''} image`}
              className="image"
            />
          </Button>
          {retailer.is_static_value && (
            <Typography variant="header1" classNames="retailer__value">
              {centsToDollarDisplay(value, true, true)}
            </Typography>
          )}
        </>
      )}
    </div>
  );
};
